module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('div', {
    class: _vm.classes,
    style: (_vm.styles)
  }, [_c('div', {
    ref: "content",
    class: [_vm.baseClass + '-content'],
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), (_vm.closable) ? _c('a', {
    class: [_vm.baseClass + '-close'],
    on: {
      "click": function($event) {
        return _vm._close()
      }
    }
  }, [_c('i', {
    staticClass: "aid aid-close"
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06653ed3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/notification/notice.vue
// module id = 340
// module chunks = 0